import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputPagger from "../../helpers/InputPagger";
import InputLegend from "../../helpers/InputLegend";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputCombo from "../../helpers/InputCombo";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";
import InputDecimal from "../../helpers/InputDecimal";
import InputDate from "../../helpers/InputDate";
import SortBy from "../../helpers/SortBy";

import search from "../../search.png";
import AppContext from "../../AppContext";
import InputText from "../../helpers/InputText";
import Xlsx from "../../exporter/Xlsx";
import MenuTable from "../../helpers/MenuTable";


import back from "../../back.png";

function Ksef(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    const [filterParam, setFilterParam] = useState({
 
               
        numer_dokumentu: props.mainView.readFilter('numer_dokumentu',''), 
        data_wystawienia_od: props.mainView.readFilter('data_wystawienia_od',''), 
        data_wystawienia_do: props.mainView.readFilter('data_wystawienia_do',''), 
        ksef_numer: props.mainView.readFilter('ksef_numer',''), 
        nip: props.mainView.readFilter('nip',''), 
        brutto_od: props.mainView.readFilter('brutto_od','0'), 
        brutto_do: props.mainView.readFilter('brutto_do','10000'), 
 
  

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
    
     
        limit: 50,
        page: 1,
        pages: 1,
        show: true,

    });

    const [tab, setTab] = useState(null);
    const [invoice, setInvoice] = useState(null);


 

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );




    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
    }


    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }



   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.master + '/rest_v1_calc,invoices_from_ksef', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);                         
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }



    const showInvoice = (row) => {

        
        props.mainView.setProgress(-2);
    

        fetch( Config.master + '/rest_v1_calc,ksef_invoice', {
            method: 'POST', 
            body: JSON.stringify({
                numer_ksef: row.numer_ksef,
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setInvoice(res.result);                                                 
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;

    }


    
    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {
  
        props.mainView.writeFilter('numer_dokumentu', ''); 
        props.mainView.writeFilter('data_wystawienia_od', ''); 
        props.mainView.writeFilter('data_wystawienia_do', ''); 
        props.mainView.writeFilter('ksef_numer', ''); 
        props.mainView.writeFilter('nip', ''); 
        props.mainView.writeFilter('brutto_od', '0'); 
        props.mainView.writeFilter('brutto_do', '10000'); 
    
   

        setFilterParam({
     
            
            numer_dokumentu: '', 
            data_wystawienia_od: '', 
            data_wystawienia_do: '', 
            ksef_numer: '', 
            nip: '', 
            brutto_od: '0', 
            brutto_do: '10000', 
         

            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },
                                       
            limit: 50,
            page: 1,
            show: true
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }




   
   

    
    if(tab == null)
        {
            setTab([]);
            getTab();
        
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
            setView( {
                v:'list',
                id: -1
            });
        }

 
    if(invoice != null)
    {

        console.log("Faktura", invoice);

        var pozycje = new Array();

        //jesli jest więcej pozycje.. to jest to Array...
        if(invoice.Fa.FaWiersz instanceof Array)
        {
            for(var k=0; k < invoice.Fa.FaWiersz.length; k++)
            {
                pozycje.push( invoice.Fa.FaWiersz[k] );
            }
        }else 
        {
             pozycje.push( invoice.Fa.FaWiersz); 
        }



        return <div className="view_content">
  
                <div className="bg_center">
                     <img src={back} onClick={()=>{ setInvoice(null); } } className="back_img" title="wstecz"/>

                   
                     <h1>{invoice.Fa.P_2} z dnia {invoice.Fa.P_1}</h1>


                    <form className="eForm bg_center">
                           <div className="form_tab_title">Dane podstawowe (nadrukowane na dokumencie):</div>
                           <div style={{padding: '5px' }}>
                                <b>Numer dokumentu: </b> {invoice.Fa.P_2}  &nbsp; &nbsp;
                                <b>Razem Netto: </b> {invoice.Fa.P_13_1}  &nbsp; &nbsp;
                                <b>Razem VAT: </b> {invoice.Fa.P_14_1}  &nbsp; &nbsp;
                                <b>Razem Brutto: </b> {invoice.Fa.P_15}  &nbsp; &nbsp;
                           </div>

                           {
                            invoice.Fa.Platnosc != undefined && invoice.Fa.Platnosc.FormaPlatnosci == '6' &&
                             <div style={{padding: '5px' }}>
                                <b>Forma płatności: </b> Przelew bankowy &nbsp; &nbsp;
                                <b>Numer rachunku: </b> {invoice.Fa.Platnosc.RachunekBankowy.NrRB} &nbsp; &nbsp;
                            </div>
                           }
                           {
                            invoice.Fa.Platnosc != undefined && invoice.Fa.Platnosc.FormaPlatnosci == '1' &&
                             <div style={{padding: '5px' }}>
                                <b>Forma płatności: </b> Gotówka &nbsp; &nbsp;                               
                            </div>
                           }

                           <br/>
                           <div className="form_tab_title">Sprzedawca:</div>
                           <div style={{padding: '5px' }}>
                                    {invoice.Podmiot1.PrefiksPodatnika} &nbsp; &nbsp;
                                    NIP: {invoice.Podmiot1.DaneIdentyfikacyjne.NIP} &nbsp; &nbsp;
                                    {invoice.Podmiot1.DaneIdentyfikacyjne.Nazwa} &nbsp; &nbsp;
                                    {invoice.Podmiot1.Adres.KodKraju} &nbsp; &nbsp;
                                    {invoice.Podmiot1.Adres.AdresL1} &nbsp; &nbsp;
                                    {invoice.Podmiot1.Adres.AdresL2} &nbsp; &nbsp;
                           </div>

                           <br/>
                           <div className="form_tab_title">Odbiorca:</div>
                           <div style={{padding: '5px' }}>
                                    {invoice.Podmiot2.PrefiksPodatnika} &nbsp; &nbsp;
                                    NIP: {invoice.Podmiot2.DaneIdentyfikacyjne.NIP} &nbsp; &nbsp;
                                    {invoice.Podmiot2.DaneIdentyfikacyjne.Nazwa} &nbsp; &nbsp;
                                    {invoice.Podmiot2.Adres.KodKraju} &nbsp; &nbsp;
                                    {invoice.Podmiot2.Adres.AdresL1} &nbsp; &nbsp;
                                    {invoice.Podmiot2.Adres.AdresL2} &nbsp; &nbsp;
                           </div>

                           
                           <br/>
                           <div className="form_tab_title">Pozycje:</div>

                            <table className="table" >

                                        <thead>
                                            <tr className="header">                                                                                            
                                                <td className="td_left">LP</td>                                                                                                                                
                                                <td>Nazwa</td>                                                                                                                                                                               
                                                <td>Cena netto</td>                                                                                                                                                                               
                                                <td>Ilość</td>                                                                                                                                                                               
                                                <td>JM</td>                                                                                                                                                                               
                                                <td>Kwota netto</td>                                                                                                                                                                                                                                                                                                                                                                                            
                                                <td className="td_right">Stawka VAT</td>                                                                                                                                                                                                    
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                pozycje.map((item, inx) => {

                                                    var rowStyle = " row ";
                                                    if(inx % 2 == 0 )rowStyle = " row2 "; 

                                                    return<tr className={rowStyle}>                                                                                            
                                                            <td className="td_left gocenter">{item.NrWierszaFa}</td>                                                                                                                                
                                                            <td>{item.P_7}</td>                                                                                                                                                                               
                                                            <td className="goright">{item.P_9A}</td>                                                                                                                                                                               
                                                            <td className="gocenter">{item.P_8B}</td>                                                                                                                                                                               
                                                            <td className="gocenter">{item.P_8A}</td>                                                                                                                                                                               
                                                            <td className="gocenter">{item.P_11}</td>                                                                                                                                                                               
                                                            <td className="gocenter">{item.P_12}</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        </tr>

                                                })
                                            }
                                        </tbody>
                            </table>

                    </form>

                </div>
        </div>        
    }




    return <div className="view_content">
 

                
                <div className="bg_center">



                {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
                } 


                {
                    filterParam.show == true  &&
                    <div className="table_filter">

                   

                       <div className="filter_controll">   
                            <label>Numer dokumentu: </label>                             
                            <InputText  userData={props.userData} value={filterParam.numer_dokumentu}   valChange={valChangeListener} goNext={goNextNew} name="numer_dokumentu" placeholder={"Numer: "}   />
                       </div> 

                        <div className="filter_controll">   
                            <label>Numer KSeF: </label>                             
                            <InputText  userData={props.userData} value={filterParam.ksef_numer}   valChange={valChangeListener} goNext={goNextNew} name="ksef_numer" placeholder={"Numer ksef: "}   />
                       </div> 


                       <div className="filter_controll filter_merge">   
                                <label>Data (od dnia / do dnia): </label>      <br/>                       
                                <InputDate   userData={props.userData} value={filterParam.data_wystawienia_od}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_od" placeholder={"Od: "}   />                                                                  
                                <InputDate   userData={props.userData} value={filterParam.data_wystawienia_do}   valChange={valChangeListener} goNext={goNextNew} name="data_wystawienia_do" placeholder={"Do: "}   />
                      </div> 




                        <div className="filter_controll filter_merge">   
                              <label>Kwota (od / do): </label>        
                              <br/>                     
                              <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.brutto_od}   valChange={valChangeListener} goNext={goNextNew} name="brutto_od" placeholder={" "}   />
                             <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.brutto_do}   valChange={valChangeListener} goNext={goNextNew} name="brutto_do" placeholder={" "}   />
                         </div> 


                         
             

                         <div className="filter_btn">
                            <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                            <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                        </div>

                  </div>
                } 
                           
 
                    <div>
                        <br/>
                         <div style={{color:'#DD0000'}}>Widok ten przedstawia faktury pobrane z KSeF. Sytem eLizak nie przechowuje tych dokumentów w swojej bazie danych.</div>
                        <br/>
                    </div>
 

                            <div className="scorll_x">
                                <table className="table" >
                                                    <thead>
                                                        <tr className="header">                                                                                                       
                                                            <td className="td_left">LP</td>  
                                                            <td>Data</td>                                                                                                                                                                                                                                                                                                             
                                                            <td>Numer</td>
                                                            <td>Numer KSeF</td>                                                                                                                                                                                   
                                                            <td>Sprzedawca</td>                                                                                                                                                                                   
                                                            <td className="">Netto</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                            <td className="">Vat</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                            <td className="td_right">Brutto</td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                            <td className="td_option"> </td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                        </tr>
                                                    </thead>
                                                    <tbody>

                                                        {
                                                            tab.map( (row,ix) => {

                                                           
                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";


                                                                return <tr className={rowStyle}>                                                                                                       
                                                                    <td>{ix+1}</td>  
                                                                    <td className="gocenter">{row.data_wystawienia}</td>                                                                                                                                                                                            
                                                                    <td>{row.numer}</td>
                                                                    <td>{row.numer_ksef}</td>
                                                                    <td>{row.sprzedawca}</td>
                                                                                                                                                                                            
                                                                    <td className={"goright" }><FormatDecimal value={row.netto} /></td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                    <td className={"goright" }><FormatDecimal value={row.vat} /></td>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
                                                                    <td className={"goright" }><FormatDecimal value={row.brutto} /></td>      
                                                                    <MenuTable>
                                                                        <ul>
                                                                                <li  atr-id={row.id} atr-title={row.numer}  onClick={ ()=>{showInvoice(row); } } >pokaż</li>
                                                                        </ul>
                                                                       
                                                                    </MenuTable>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                                </tr>    

                                                            } )
                                                        }
 
                                                    </tbody>
                                </table>
                            </div>


                </div>


           </div>
}




export default Ksef;